export const accountList = [
    {
        id: '01',
        label: '资产类',
        isDefaultExpanded: true,
        children: [
            {
                label: '库存现金',
                id: '1001'
            },
            {
                label: '银行存款',
                id: '1002'
            },
            {
                label: '其他货币资金',
                id: '1015'
            },
            {
                label: '交易性金融资产',
                id: '1101'
            }
        ]
    },
    {
        id: '02',
        label: '负债类',
        isDefaultExpanded: false,
        children: [
            {
                label: '短期借款',
                id: '2001'
            },
            {
                label: '交易性金融负债',
                id: '2101'
            },
            {
                label: '应付票据',
                id: '2201'
            },
            {
                label: '应付帐款',
                id: '2202'
            }
        ]
    },
    {
        id: '03',
        label: '所有者权益类',
        isDefaultExpanded: false,
        children: [
            {
                label: '实收资本',
                id: '4001'
            },
            {
                label: '资本公积',
                id: '4002'
            },
            {
                label: '盈余公积',
                id: '4101'
            },
            {
                label: '本年利润',
                id: '4103'
            },
            {
                label: '利润分配',
                id: '4104'
            },
            {
                label: '库存股',
                id: '4201'
            }
        ]
    },
    {
        id: '04',
        label: '成本类',
        isDefaultExpanded: false,
        children: [
            {
                label: '生产成本',
                id: '5001'
            },
            {
                label: '制造费用',
                id: '5101'
            },
            {
                label: '劳务成本',
                id: '5201'
            },
            {
                label: '研发支出',
                id: '5301'
            }
        ]
    },
    {
        id: '05',
        label: '损益类',
        isDefaultExpanded: false,
        children: [
            {
                label: '主营业务收入',
                id: '6001'
            },
            {
                label: '利息收入',
                id: '6011'
            },
            {
                label: '其他业务收入',
                id: '6051'
            },
            {
                label: '投资收益',
                id: '6111'
            },
            {
                label: '营业外收入',
                id: '6301'
            },
            {
                label: '主营业务成本',
                id: '6401'
            }
        ]
    }
    
]